class GallerySK {
	constructor(parent) {
		this._init()
	}
	_init() {
        // this.root = document.querySelector('[data-gallery-sk]')

        // if (!this.root) {
        //     return
        // }

        // this.dst = document.querySelector('[data-gallery-sk-dst]')

        // let idxBase = 0
        // document.querySelectorAll('[data-gallery-sk-src]').forEach(el => {
        //     const idx = idxBase++
        //     el.addEventListener('click', () => {
        //         this.hideDst(idx)
        //         setTimeout(() => {
        //             let src = el.querySelector('img').src
        //             if (el.querySelector('img').dataset.sizeW1920) {
        //                 src = el.querySelector('img').dataset.sizeW1920
        //             }
        //             const img = new Image();
        //             img.onload = () => {
        //                 this.dst.style.backgroundImage = 'url(' + src + ')'
        //                 this.showDst(idx)
        //             }
        //             img.src = src;
        //         }, 400)
        //     })
        // })
	}
    hideDst(idx) {
        this.dst.style.opacity = "0"
        this.dst.style.transition = "opacity 0.3s"
    }
    showDst(idx) {
        this.dst.style.opacity = "1"
        const event = new CustomEvent('item-change', { detail: idx });
        document.dispatchEvent(event);
    }
}

export default GallerySK
